import api from '@/api/index.js'

const cards = {
  state: {
    loading: false,
    data: [],
    filterDetails: null,
    error: null
  },

  mutations: {
    SET_CARDS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_CARDS: (state, response) => {
      state.loading = false
      state.data = [];
      if (response == null) {
        return
      }
      state.data = response
    },
    SET_CARDS_ERROR: (state, error) => {
      state.error = error
    },
    SET_CARDS_FILTER_DETAILS: (state, filterDetails) => {
      state.filterDetails = filterDetails
    }
  },

  actions: {
    LoadCards({commit}, query) {
      commit('SET_CARDS', {
        data: [],
        pagination: {
          offset: 0,
          limit: 0,
          total: 0,
        }
      })
      commit('SET_CARDS_FILTER_DETAILS', query)
      commit('SET_CARDS', null)
      commit('SET_CARDS_ERROR', null)
      commit('SET_CARDS_LOADING', true)
      return api.get(`cards?public_id=${escape(query.publicId)}&limit=150&offset=0`)
        .then((response) => {
          commit('SET_CARDS', response)
        })
        .catch((error) => {
          commit('SET_CARDS_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_CARDS_LOADING', false)
        })
    }
  }
}

export default cards
